var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnPlayReport2 = function SvgIcnPlayReport2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.933 10.2811V19.9499C21.933 22.9249 20.1579 23.9165 17.9663 23.9165H10.033C7.84143 23.9165 6.06635 22.9249 6.06635 19.9499V10.2811C6.06635 7.0582 7.84143 6.31445 10.033 6.31445C10.033 6.92929 10.2809 7.48462 10.6875 7.8912C11.0941 8.29778 11.6494 8.5457 12.2643 8.5457H15.7351C16.9648 8.5457 17.9663 7.54412 17.9663 6.31445C20.1579 6.31445 21.933 7.0582 21.933 10.2811Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.967 6.31523C17.967 7.5449 16.9654 8.54648 15.7357 8.54648H12.2649C11.65 8.54648 11.0947 8.29856 10.6881 7.89198C10.2815 7.4854 10.0336 6.93007 10.0336 6.31523C10.0336 5.08557 11.0352 4.08398 12.2649 4.08398H15.7357C16.3505 4.08398 16.9059 4.3319 17.3125 4.73849C17.7191 5.14507 17.967 5.7004 17.967 6.31523Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0336 14.9902H14.0003",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0336 18.959H17.967",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnPlayReport2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_play_report2.a49c3086.svg";
export { ForwardRef as ReactComponent };